export const formatJson = (json?: string) =>
    json ? JSON.stringify(JSON.parse(json), null, 2) : ""
